import React from "react";
import logoutImg from "../assets/logout/logout.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Logout({ onCancel }) {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleLogout = () => {
        localStorage.removeItem("productData");
        logout(); // 👈 Clears session and updates UI state
        navigate("/");
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="lg:w-[30vw] h-[75vh] md:w-[80vw] sm:w-[80vw] w-[90vw]    bg-[white] border border-[black] rounded-[22.78px] display flex flex-col px-12 py-12 gap-12 items-center justofy-center ">
                <div className="w-[70%] h-[50%] ">
                    <img src={logoutImg} alt="logout" style={{ width: "100%", height: "100%" }} />
                </div>
                <span className="w-[100%] flex justify-center items-center text-center font-[400] text-3xl font-display">
                    Are you sure you want to logout?
                </span>
                <div className="w-[100%] flex flex-row justify-center items-center gap-8">
                    <span className="font-[700] text-2xl font-display text-[#8B0000] cursor-pointer" onClick={onCancel}>
                        Cancel
                    </span>
                    <span
                        className="w-[50%] h-[50px] rounded-[3.42px] bg-[#8B0000] text-[white] flex justify-center items-center font-[700] text-2xl font-display cursor-pointer"
                        onClick={handleLogout}
                    >
                        Logout
                    </span>
                </div>
            </div>
        </div>
    );
}

export default Logout;
